// InventoryServices/InventoryInfoTabs/InfoTabsAPI.js
import { axiosInstance } from "../../../Services";

const API_KEY = "01e335a5ed3e9f73a270f3c5dd3161c5";

export const getFormStructure = async (id) => {
  const res = await axiosInstance.get(`/rsform/inventories/${id}/form`, {
  });
  return res.data;
};

export const getFormStructureDetails = async (id) => {
  const res = await axiosInstance.get(`/rsform/inventories/${id}/details`);
  return res.data;
};

export const getExistingData = async (id) => {
  const res = await axiosInstance.get(`/rsform/inventories/${id}/data`, {
  });
  return res.data;
};

export const saveFormData = async (id, values, existingDataId = null) => {
  // Send as JSON payload instead of FormData
  const payload = { ...values };
  
  // Ensure any null/undefined values are handled as empty strings if needed
  Object.keys(payload).forEach(key => {
    if (payload[key] == null) {
      payload[key] = "";
    }
  });

  if (existingDataId) {
    // PATCH existing data
    const res = await axiosInstance.patch(
      `/rsform/inventories/data/${existingDataId}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } else {
    // POST new data
    const res = await axiosInstance.post(
      `/rsform/inventories/form/${id}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  }
};